module.exports = __webpack_public_path__ + "static/media/receipt.39e7d14a.jpg";